import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

import { ValidatorUtils, StringUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar, Input, Button, Errors } from  '../../components'
import publicIp from 'public-ip';

class PracticeBankAddEditScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      routingNumber: '',
      accountNumber: '',
      businessName: '',
      display_stripe_modal: false,
      validation: {},
      temporaryLoading: false,
    }
  }

  componentDidMount() {
    let token = this.props.user.auth.token;
    let selectedPracticeID = this.props.context.selectedPractice;

    if (token && selectedPracticeID) {
      this.props.practiceActions.getPracticeStripeAccount(token, selectedPracticeID);
    }
  }

  renderLine = () => {
    return <div style={{ height: 1, width: '100%', backgroundColor: '#e7e7e7', marginTop: 20, marginBottom: 20 }}></div>
  }

  renderBusinessInfoSection = (business_name, practice_id) => {

    let hide_input = business_name ? true : false;

    return <div className="flex-container-column">
      <div className="flex-container-row" style={{ justifyContent: 'space-between' }}>
      <span style={{ fontSize: 18 }}>Business Info</span>
      { hide_input ? <span className="fas fa-check-circle" style={{ fontSize: 20, color: '#66D56F', marginTop: 3 }}></span>
                   : <span className="far fa-circle" style={{ fontSize: 20, color: '#e7e7e7', marginTop: 3 }}></span> }
      </div>

      <div className='flex-container-column' style={{  }}>

        { hide_input ? <div className="flex-container flex-container-column"  style={{ }}>
            <span style={{ marginTop: 5, color: 'grey', fontSize: 15 }}>{ business_name }</span>
            <span style={{ fontWeight: 'bold', color: '#1dc2ff', fontSize: 11 }}>BUSINESS NAME</span>
          </div>
        : <div className="flex-container flex-container-row"  style={{ justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
            <div style={{ width: '50%'}}>
              <Input  style={{ width: '100%', fontSize: 14 }}
                      placeholder="Business Name"
                      value={this.state.businessName}
                      invalid={this.state.validation.fields && this.state.validation.fields['businessName']}
                      onChange={ (event) => {
                        this.setState({ ...this.state, businessName: event.target.value })
                      }}
                    />
            </div>
            <div className='flex-container-row' style={{ justifyContent: 'flex-end', alignItems: 'center' }}>
              <Button value="Save"
                      loading={this.props.loading && this.props.loading.setBankCompanyName}
                      style={{ marginRight: 5, paddingTop: 6, paddingBottom: 6 }}
                      onClick={ () => {
                        this.saveCreateStripeAccountAction(practice_id);
                      }}
                    />
            </div>
        </div> }

      </div>
    </div>
  }

  renderAccountVerificationInfoSection = (stripeAccount) => {
    let section_enabled   = stripeAccount ? true : false;
    let verification_link = this.props.practice && this.props.practice.stripeVerificationLink ? this.props.practice.stripeVerificationLink : null;
    let update_link       = this.props.practice && this.props.practice.stripeUpdateLink ? this.props.practice.stripeUpdateLink : null;

    let verification_url  = verification_link && verification_link.url ? verification_link.url : '';
    let update_url        = update_link && update_link.url ? update_link.url : '';

    let outstanding_requirements = stripeAccount && stripeAccount.requirements && stripeAccount.requirements.eventually_due ? stripeAccount.requirements.eventually_due : [];
    let only_bank_needed         = outstanding_requirements && outstanding_requirements.length === 1 && outstanding_requirements[0] === 'external_account' ? true : false;
    let no_requirements          = outstanding_requirements && stripeAccount && outstanding_requirements.length === 0 ? true : false;
    let id_requirement_pending   = this.isIdRequirementPending(outstanding_requirements);

    return <div className="flex-container-column">
      { this.renderStripeModal(verification_url) }
      <div className="flex-container-row" style={{ justifyContent: 'space-between', marginBottom: 10 }}>
        <div className='flex-container-column' style={{  }}>
          <span style={{ fontSize: 18 }}>Payment Account Verification</span>
          <span style={{ width: '80%', fontWeight: 'bold', color: 'grey', fontSize: 13 }}>Payments may not be processed until the verification process has been completed</span>
        </div>
        { no_requirements && section_enabled ? <span className="fas fa-check-circle" style={{ fontSize: 20, color: '#66D56F', marginTop: 3 }}></span>
                          : <span className="far fa-circle" style={{ fontSize: 20, color: '#e7e7e7', marginTop: 3 }}></span> }
      </div>
      <div className="flex-container-row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ }}>
          { no_requirements ? <div className='flex-container-column' style={{ marginTop: 5, marginBottom: 5 }}>
                                <span style={{ marginTop: 5, color: '#66D56F', fontSize: 15 }}>Enabled</span>
                                <span style={{ fontWeight: 'bold', color: '#1dc2ff', fontSize: 11 }}>PAYMENTS STATUS</span>
                              </div>
                            : <div className='flex-container-row' style={{ alignItems: 'center' }}>
                                {  this.state.temporaryLoading ? <Spinner as="span" animation="border" size='sm' style={{ color: '#1dc2ff', marginRight: 10 }} /> : null }
                                {  this.state.temporaryLoading ? <span style={{ color: 'grey', fontSize: 15 }}>{ 'Processing validation requirements...' }</span> : null }
                                { !this.state.temporaryLoading ? <span style={{ color: 'orange', fontSize: 15 }}>{ id_requirement_pending ? 'ID Validation Pending' : 'Outstanding Requirements' }</span> : null }
                              </div> }

        </div>


        { no_requirements ? null
        :<div className="flex-conatiner-row" style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
          <span className="button-clear-blue" style={{ marginRight: 5, justifyContent: 'center', alignItems: 'center' }} onClick={ () => { this.refreshStripeData() }}>
            <span className="fas fa-sync-alt" style={{ fontSize: 14, color: section_enabled ? '#1dc2ff' : '#e7e7e7', marginTop: 4 }}></span>
          </span>
          <span>
            <a className="button-default"
               style={{ color: 'white', textDecoration: 'none', backgroundColor: section_enabled ? '' : '#e7e7e7' }}
               href={ section_enabled ? verification_url : null }
               target='_blank'
               onClick={ () => {
                 if (section_enabled) {
                   this.setState({ ...this.state, display_stripe_modal: true })
                 }
               }}>{ id_requirement_pending ? 'Complete ID Requirement' : 'Complete Requirements' }</a>
           </span>
        </div> }

      </div>
    </div>
  }

  renderStripeModal = (stripe_url) => {

    return <Modal show={this.state.display_stripe_modal}
                  onHide={ () => { this.modalCloseAction() }}>
      <div className='flex-container-column' style={{ padding: 15 }}>
        <h4>Payment Account Verification</h4>
        <div className='flex-container-column' style={{ marginTop: 5 }}>
          <span style={{ fontSize: 14, color: 'grey' }}>Verification data processing can take some time and may not immediately reflect on your account. </span>
          <span style={{ fontSize: 14, color: 'grey', marginTop: 10 }}>You can click the <span className="fas fa-sync-alt" style={{ fontSize: 14, color: '#1dc2ff', marginLeft: 3, marginRight: 3 }}></span> Refresh icon to pull the latest data if it doesn't auto-load.</span>
        </div>
        <div className='flex-container-row' style={{ justifyContent: 'flex-end', marginTop: 10 }}>
          <Button value='Done'
                  className='button-clear-blue'
                  style={{  }}
                  onClick={ () => { this.modalCloseAction() }}
                />
        </div>
      </div>
    </Modal>
  }

  renderBankInfoSection = (bank, bank_exists, business_name, stripe_id, practice_id) => {
    let enable_bank_input = business_name ? true : false;
    let current_bank      = this.props.practice && this.props.practice.bank ? this.props.practice.bank : {};
    let bank_is_valid     = current_bank && current_bank.last4 ? true : false;
    let bank_name         = current_bank && current_bank.bank_name ? current_bank.bank_name : current_bank.bank_name;

    return <div className="flex-container-column">
      <div className="flex-container-row" style={{ justifyContent: 'space-between', marginBottom: 10 }}>
        <span style={{ fontSize: 18 }}>Bank Info</span>
        { bank_is_valid ? <span className="fas fa-check-circle" style={{ fontSize: 20, color: '#66D56F', marginTop: 3 }}></span>
                        : <span className="far fa-circle" style={{ fontSize: 20, color: '#e7e7e7', marginTop: 3 }}></span> }
      </div>

      { !bank_is_valid ? null
      : <div className='flex-container-column' style={{ marginBottom: 15 }}>
          <span style={{ fontSize: 14, color: 'grey' }}>{ bank_name }</span>
          <div className='flex-container-row' style={{ alignItems: 'center' }}>
            <span className="fas fa-dot-circle" style={{ fontSize: 10, color: 'grey', marginRight: 2 }}></span>
            <span className="fas fa-dot-circle" style={{ fontSize: 10, color: 'grey', marginRight: 2 }}></span>
            <span className="fas fa-dot-circle" style={{ fontSize: 10, color: 'grey', marginRight: 2 }}></span>
            <span className="fas fa-dot-circle" style={{ fontSize: 10, color: 'grey', marginRight: 2 }}></span>
            <span className="fas fa-dot-circle" style={{ fontSize: 10, color: 'grey', marginRight: 2 }}></span>
            <span className="fas fa-dot-circle" style={{ fontSize: 10, color: 'grey', marginRight: 2 }}></span>
            <span className="fas fa-dot-circle" style={{ fontSize: 10, color: 'grey', marginRight: 2 }}></span>
            <span className="fas fa-dot-circle" style={{ fontSize: 10, color: 'grey', marginRight: 4 }}></span>
            <span style={{ fontSize: 15, color: 'grey' }}>{ current_bank.last4 }</span>
          </div>
          <div>
            <span style={{ fontWeight: 'bold', color: '#1dc2ff', fontSize: 11 }}>CURRENT BANK ACCOUNT</span>
          </div>
        </div>
      }


      <div className="flex-container-row" style={{ justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div className="flex-container-column" style={{ width: '50%'}}>
          <Input  style={{ marginTop: 0, fontSize: 14 }}
                  placeholder="Account Number"
                  value={this.state.accountNumber}
                  invalid={this.state.validation.fields && this.state.validation.fields['accountNumber']}
                  onChange={ (event) => {
                    this.setState({ ...this.state, accountNumber: event.target.value })
                  }}
                />
          <Input  style={{ marginTop: 5, fontSize: 14 }}
                  placeholder="Routing Number"
                  value={this.state.routingNumber}
                  invalid={this.state.validation.fields && this.state.validation.fields['routingNumber']}
                  onChange={ (event) => {
                    this.setState({ ...this.state, routingNumber: event.target.value })
                  }}
                />
        </div>
        <div>
          <Button value={ bank_is_valid ? 'Replace Bank' : 'Save Bank' }
                  loading={this.props.loading && this.props.loading.saveBank}
                  disabled={!enable_bank_input}
                  style={{ marginRight: 5, paddingTop: 8, paddingBottom: 8, backgroundColor: enable_bank_input ? '' : '#e7e7e7' }}
                  onClick={ () => {
                    let token = this.props.user.auth.token;
                    let bank_info = {
                      practice_id: practice_id,
                      routing_number: this.state.routingNumber,
                      account_number: this.state.accountNumber,
                      stripe_account_id: stripe_id,
                    }

                    if (practice_id && stripe_id) {
                      this.props.practiceActions.addPracticeBank(token, bank_info, this.bankSaveAction);
                    }
                  }}
                />
        </div>
      </div>
    </div>
  }

  renderAddEditBankSection = (bank, bankExists, practice_id, stripeAccount) => {

    if (!practice_id) {
      return null;
    }
    let current_bank  = this.props.practice && this.props.practice.bank ? this.props.practice.bank : {};
    let bank_is_valid = current_bank && current_bank.last4 ? true : false;
    let business_name = stripeAccount && stripeAccount.company && stripeAccount.company.name ? stripeAccount.company.name : '';
    let stripe_id     = stripeAccount && stripeAccount.id ? stripeAccount.id : '';

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">

        <div className="basic-container">
          { this.renderBusinessInfoSection(business_name, practice_id) }
          { this.renderLine() }
          { this.renderBankInfoSection(bank, bankExists, business_name, stripe_id, practice_id) }
          { this.renderLine() }
          { this.renderAccountVerificationInfoSection(bank_is_valid ? stripeAccount : null) }
        </div>

      </div>
    </div>
  }

  render() {

    const allPractices = this.props.user.practices;
    const selectedPracticeID = this.props.context.selectedPractice;
    const selectedPractice   = allPractices && allPractices[selectedPracticeID] ? allPractices[selectedPracticeID] : null;
    const bank = this.props.practice && this.props.practice.bank ? this.props.practice.bank : null;
    const bankExists = bank ? true : false;
    const stripeAccount = this.props.practice && this.props.practice.stripeAccount ? this.props.practice.stripeAccount : null;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Add a new Bank" />
        { this.renderAddEditBankSection(bank, bankExists, selectedPracticeID, stripeAccount) }
      </div>
    );
  }

  saveCreateStripeAccountAction = (practice_id) => {
    let token = this.props.user.auth.token;
    let account_info = {};

    account_info['business_name'] = this.state.businessName || '';
    account_info['practice_id']   = practice_id;

    if (token && account_info.business_name && account_info.practice_id) {
      this.props.practiceActions.createPracticeStripeAccount(token, account_info);
    }
  }

  modalCloseAction = () => {
    this.refreshStripeData();
  }

  refreshStripeData = () => {
    this.startTemporaryTimer();
  }

  isIdRequirementPending = (requirements) => {
    let requirements_array     = requirements || [];
    let id_requirement_pending = false;

    requirements_array.forEach((requirement_string) => {
      if (requirement_string.includes('verification.document')) {
        id_requirement_pending = true;
      }
    });

    return id_requirement_pending;
  }

  bankSaveAction = () => {
    this.setState({
      ...this.state,
      routingNumber: '',
      accountNumber: ''
    })
  }

  successAction = () => {
    NavigationActions.navigateBack();
  }

  startTemporaryTimer = () => {
    this.setState({ ...this.state, temporaryLoading: true, display_stripe_modal: false })
    setTimeout( () => {
      let token = this.props.user.auth.token;
      let selectedPracticeID = this.props.context.selectedPractice;

      if (token && selectedPracticeID) {
        this.props.practiceActions.getPracticeStripeAccount(token, selectedPracticeID);
      }

      this.setState({
        temporaryLoading: false,
      })
    }, 5000);
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeBankAddEditScreen)
